import { render, staticRenderFns } from "./pc-created.vue?vue&type=template&id=dda6db16"
import script from "./pc-created.vue?vue&type=script&lang=js"
export * from "./pc-created.vue?vue&type=script&lang=js"
import style0 from "./pc-created.vue?vue&type=style&index=0&id=dda6db16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports